import { createAPI } from "../apisServer";

import BaseUrl from "../baseUrls";

const banco = BaseUrl.dataBase;
const apiServer = createAPI("multiTenant");

const reqVendaItem = {
	listSoldProducts: async function (body) {
		return apiServer
			.get("portal/v1/venda-item", {
				params: body,
				headers: {
					banco: banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
	curvaABC: async function (body) {
		return apiServer
			.get("portal/v1/venda-item/curve-abc", {
				params: body,
				headers: {
					banco: banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
	listGradeVendidosV2: async function (body) {
		return apiServer
			.get("portal/v2/venda-item/grade", {
				params: body,
				headers: {
					banco: banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
	listGradeVendidos: async function (body) {
		return apiServer
			.get("portal/v1/venda-item/grade", {
				params: body,
				headers: {
					banco: banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
	itemFaturamento: async function (body) {
		return apiServer
			.get("portal/v1/venda-item/faturamento", {
				params: body,
				headers: {
					banco: banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
	listGradeVendidosSum: async function (body) {
		return apiServer
			.get("portal/v1/venda-item/grade/sum", {
				params: body,
				headers: {
					banco: banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
	listByVenda: async function (id) {
		return apiServer
			.get(`portal/v1/vendaitem/venda/${id}`, {
				headers: {
					banco: banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
};

export default reqVendaItem;
